import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import cx from 'classnames';

import { useNotificationsQuery } from 'hooks/queries/useNotificationsQuery';
import { getNewDialogsCount } from 'store/common/selectors';

import { ReactComponent as FinderIcon } from 'assets/icons/simple-dates/finder.svg';
import { ReactComponent as LikesIcon } from 'assets/icons/simple-dates/likes.svg';
import { ReactComponent as MessagesIcon } from 'assets/icons/simple-dates/messages.svg';
import { ReactComponent as ProfileIcon } from 'assets/icons/simple-dates/profile.svg';

import { Logo } from 'components/shared/Logo';

import { DesktopMaxWidthContainer } from '../DesktopMaxWidthContainer';

import css from './privateHeader.module.sass';

export const PrivateHeader: React.FC = () => {
  const { t } = useTranslation('common');

  const newDialogsCount = useSelector(getNewDialogsCount);

  const notificationPageDataQuery = useNotificationsQuery();

  useEffect(() => {
    notificationPageDataQuery.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <header className={cx(css.root)}>
      <DesktopMaxWidthContainer>
        <div className={css.wrapper}>
          <Link to="/">
            <Logo className={css.logo} hideBottomLine />
          </Link>
          <ul className={css.list}>
            <li className={css.item}>
              <NavLink
                to="/finder"
                exact
                className={css.link}
                activeClassName={css.linkStateActive}
              >
                <FinderIcon className={css.icon} />
                <p className={css.text}>{t('sidebar.finder')}</p>
              </NavLink>
            </li>
            <li className={css.item}>
              <NavLink
                to="/likes"
                exact
                className={css.link}
                activeClassName={css.linkStateActive}
              >
                <div className={css.iconWrapper}>
                  {!!notificationPageDataQuery.data?.likes?.count_new && (
                    <div className={css.activeBadge}>
                      {notificationPageDataQuery.data?.likes?.count_new > 99
                        ? '99+'
                        : notificationPageDataQuery.data?.likes?.count_new}
                    </div>
                  )}
                  <LikesIcon className={css.icon} />
                </div>
                <p className={css.text}>{t('likes')}</p>
              </NavLink>
            </li>
            <li className={css.item}>
              <NavLink
                to="/threads"
                className={css.link}
                activeClassName={css.linkStateActive}
              >
                <div className={css.iconWrapper}>
                  {!!newDialogsCount && (
                    <div className={css.activeBadge}>{newDialogsCount}</div>
                  )}
                  <MessagesIcon
                    className={css.icon}
                    width="26px"
                    height="26px"
                  />
                </div>
                <p className={css.text}>{t('sidebar.messages')}</p>
              </NavLink>
            </li>
            <li className={css.item}>
              <NavLink
                to="/myprofile"
                exact
                className={css.link}
                activeClassName={css.linkStateActive}
              >
                <ProfileIcon className={css.icon} />
                <p className={css.text}>Profile</p>
              </NavLink>
            </li>
          </ul>
        </div>
      </DesktopMaxWidthContainer>
    </header>
  );
};
